import { useEffect, useRef } from "react";

// runs onSettled once per new {caseId}-shaped signal that matches caseId
const useSettledSignalEffect = ({ signal, caseId, isEnabled, onSettled }) => {
  const handledSignalRef = useRef(null);
  useEffect(() => {
    if (!isEnabled || !signal || handledSignalRef.current === signal) return;
    handledSignalRef.current = signal;
    if (signal.caseId !== caseId) return;
    onSettled();
  }, [signal, caseId, isEnabled, onSettled]);
};

export default useSettledSignalEffect;
